(function () {
  'use strict';

  // Ao clicar no botão de solicitação
  $('.btn-get-award').on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const $infos = $btn.parent().parent('.award-timeline-item-infos');
    const awardRef = $btn.data('ref');
    const awardTit = $infos.find('.award-timeline-item-text').text();
    const awardValue = $infos.find('.award-timeline-item-tit').text();
    $('.aw-form-ref-view b').text(awardValue);
    $('.aw-form-ref-view small').text(awardTit);
    $('#aw-ref').val(awardRef);
    $('#aw-tit').val(awardTit);
    $('#modal-award').modal('show');
  });
})();
